const ITEMS = [
  "REACT 19", "PYTHON FASTAPI", "LLM AGENTS", "NEXT.JS ARCHITECTURE",
  "TAILWIND CSS", "NEON / POSTGRES", "DOCKER & CLOUD", "AI INTEGRATION",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative border-y border-white/10 bg-surface/60 py-6 overflow-hidden marquee-mask" data-testid="tech-marquee">
      <div className="flex w-max animate-marquee items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center shrink-0" aria-hidden={half === 1 ? "true" : undefined}>
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center shrink-0" aria-hidden={i >= ITEMS.length ? "true" : undefined}>
                <span className={`font-display font-bold text-2xl sm:text-4xl tracking-tight px-6 ${i % 2 === 0 ? "text-outline-white" : "text-slate-700"}`}>
                  {item}
                </span>
                <span className="text-cyan-400/70 font-mono text-lg">{"//"}</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
